import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=c09e2c58&"
import script from "./EditModal.vue?vue&type=script&lang=ts&"
export * from "./EditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports